export default __webpack_public_path__ + "static/media/1_1.f24dab09.png";